
export let activeSignTableLabels = [
  {
    label: '活动名称',
    value: 'name'
  },
  {
    label: '分子公司',
    value: 'branchVO.name'
  },
  {
    label: '参加数量上限',
    value: 'maxNumber'
  },
  {
    label: '报名开始时间',
    value: 'start_time'
  },
  {
    label: '报名截止时间',
    value: 'end_time'
  },
  {
    label: '已报名人数',
    value: 'sizeNumber'
  }
]
export let questionSignTableLabels = [
  {
    label: '问卷名称',
    value: 'name'
  },
  {
    label: '分子公司',
    value: 'branchVO.name'
  },
  {
    label: '参加数量上限',
    value: 'maxNumber'
  },
  {
    label: '报名开始时间',
    value: 'start_time'
  },
  {
    label: '报名截止时间',
    value: 'end_time'
  },
  {
    label: '已提交人数',
    value: 'sizeNumber'
  }
]
export let parseSignTableLabels = [
  {
    label: '名称',
    value: 'name'
  },
  {
    label: '分子公司',
    value: 'branchVO.name'
  },
  {
    label: '报名开始时间',
    value: 'start_time'
  }
]
